






























































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { CvValue, EditorialProject, SearchProductOptionsMultiples } from '@/models'
import {
  CV_VALUE_COUNTRY, CV_VALUE_EDITORIAL_PROJECT_STATUS, CV_VALUE_PRODUCT_WORK_TYPE, CV_VALUE_SUBJECT,
  CV_VALUE_EDUCATION, CV_VALUE_TYPE_PROD, CV_VALUE_LANGUAGE, CV_VALUE_COURSE_LEVEL
} from '@/utils/constants'
import { CvValueUtils } from '@/utils/cv-value-utils'
import { ActionTypes } from '@/store/action-types'
import { orderBy } from 'lodash'
import { Utils } from '@/utils'

@Component
export default class ProductListFilters extends Vue {
  @Prop({ required: true, type: Object }) productFilters: SearchProductOptionsMultiples
  @Prop({ required: true, type: Number }) currentPage: number

  private CV_VALUE_EDITORIAL_PROJECT_STATUS = CV_VALUE_EDITORIAL_PROJECT_STATUS
  private CV_VALUE_TYPE_PROD = CV_VALUE_TYPE_PROD

  private years: Array<number> = Utils.getYearsForCampaign(2019)
  private educationLevels: CvValue[] = []
  private productTypes: CvValue[] = []
  private countries: CvValue[] = []
  private workTypes: CvValue[] = []
  private cvSubject: CvValue[] = []
  private cvLanguage: CvValue[] = []
  private cvCourseLevel: CvValue[] = []
  private developmentManagers: string[] = []
  private utils = Utils

  private delaySearch = Utils.delay(this.search, 500)

  get editorialProjects() {
    return this.$store.getters.editorialProjects
  }

  get editorialProjectsOptions() {
    const options = []

    // Order editorial projects correct
    const editorialProjects = orderBy(this.editorialProjects, ['country', 'businessUnit', 'enabled', 'yearStart', 'name'], ['asc', 'asc', 'desc', 'desc', 'asc'])

    for (const country of this.countries) {
      options.push({
        codeId: country.codeId,
        name: country.name,
        selectable: false
      })
      options.push(...editorialProjects.filter((editorialProject: EditorialProject) => editorialProject.country === country.codeId).map((editorialProject: EditorialProject) => {
        return {
          codeId: editorialProject.id,
          name: editorialProject.name,
          status: editorialProject.status,
          selectable: true
        }
      }))
    }

    return options
  }

  get educationLevelsOrder() {
    return orderBy(this.educationLevels, ['orderNum'])
  }

  get languageSelect() {
    return this.cvLanguage
  }

  get courseLevelSelect() {
    return this.cvCourseLevel
  }

  @Watch('productFilters', { deep: true })
  onFiltersTableChanged() {
    this.updateUrlQueryParams()
    this.delaySearch.apply(this)
  }

  @Watch('currentPage')
  onCurrentPageChanged() {
    this.updateUrlQueryParams()
  }

  async created() {
    this.loadFiltersFromUrl()

    this.loadEditorialProjects()
    this.loadEducationLevels()
    this.loadTypeProduct()
    this.loadCountry()
    this.loadWorkType()
    this.loadSubject()
    this.loadLanguage()
    this.loadCourseLevel()
    this.loadDevelopmentManagers()
    this.loadStatuses()
  }

  private loadFiltersFromUrl() {
    if (this.$route.query.search) {
      this.productFilters.search = this.$route.query.search.toString()
    }

    if (this.$route.query.educationLevel1) {
      this.productFilters.educationLevel1 = this.$route.query.educationLevel1.toString().split(',')
    }

    if (this.$route.query.manager) {
      this.productFilters.manager = this.$route.query.manager.toString().split(',')
    }

    if (this.$route.query.type) {
      this.productFilters.type = this.$route.query.type.toString().split(',')
    }

    if (this.$route.query.country) {
      this.productFilters.country = this.$route.query.country.toString().split(',')
    }

    if (this.$route.query.editorialProject) {
      this.productFilters.editorialProject = this.$route.query.editorialProject.toString().split(',')
    }

    if (this.$route.query.subject) {
      this.productFilters.subject = this.$route.query.subject.toString().split(',')
    }

    if (this.$route.query.productionCampaign) {
      this.productFilters.productionCampaign = this.$route.query.productionCampaign.toString().split(',')
    }

    if (this.$route.query.workType) {
      this.productFilters.workType = this.$route.query.workType.toString().split(',')
    }

    if (this.$route.query.language) {
      this.productFilters.language = this.$route.query.language.toString().split(',')
    }

    if (this.$route.query.educationLevel2) {
      this.productFilters.educationLevel2 = this.$route.query.educationLevel2.toString().split(',')
    }

    this.search()
  }

  private updateUrlQueryParams() {
    const queries: any = {}

    if (this.productFilters.search && this.productFilters.search !== '') {
      queries.search = this.productFilters.search
    }

    if (this.productFilters.educationLevel1 && this.productFilters.educationLevel1.length > 0) {
      queries.educationLevel1 = this.productFilters.educationLevel1.join(',')
    }

    if (this.productFilters.manager && this.productFilters.manager.length > 0) {
      queries.manager = this.productFilters.manager.join(',')
    }

    if (this.productFilters.type && this.productFilters.type.length > 0) {
      queries.type = this.productFilters.type.join(',')
    }

    if (this.productFilters.country && this.productFilters.country.length > 0) {
      queries.country = this.productFilters.country.join(',')
    }

    if (this.productFilters.editorialProject && this.productFilters.editorialProject.length > 0) {
      queries.editorialProject = this.productFilters.editorialProject.join(',')
    }

    if (this.productFilters.subject && this.productFilters.subject.length > 0) {
      queries.subject = this.productFilters.subject.join(',')
    }

    if (this.productFilters.productionCampaign && this.productFilters.productionCampaign.length > 0) {
      queries.productionCampaign = this.productFilters.productionCampaign.join(',')
    }

    if (this.productFilters.workType && this.productFilters.workType.length > 0) {
      queries.workType = this.productFilters.workType.join(',')
    }

    if (this.productFilters.language && this.productFilters.language.length > 0) {
      queries.language = this.productFilters.language.join(',')
    }

    if (this.productFilters.educationLevel2 && this.productFilters.educationLevel2.length > 0) {
      queries.educationLevel2 = this.productFilters.educationLevel2.join(',')
    }

    if (this.currentPage) {
      queries.currentPage = this.currentPage.toString()
    }

    if (JSON.stringify(queries) === JSON.stringify(this.$route.query)) {
      return
    }

    this.$router.replace({ query: queries })
  }

  private async loadEditorialProjects() {
    this.$store.dispatch(ActionTypes.LOAD_EDITORIAL_PROJECTS)
  }

  private async loadTypeProduct() {
    this.productTypes.push(...await CvValueUtils.getCvValuesByType(CV_VALUE_TYPE_PROD))
  }

  private async loadSubject() {
    this.cvSubject = await CvValueUtils.getCvValuesByType(CV_VALUE_SUBJECT)
  }

  private async loadEducationLevels() {
    this.educationLevels.push(...await CvValueUtils.getCvValuesByType(CV_VALUE_EDUCATION))
  }

  private async loadCountry() {
    this.countries.push(...await CvValueUtils.getCvValuesByType(CV_VALUE_COUNTRY))
  }

  private async loadWorkType() {
    this.workTypes.push(...await CvValueUtils.getCvValuesByType(CV_VALUE_PRODUCT_WORK_TYPE))
  }

  private async loadStatuses() {
    await CvValueUtils.getCvValuesByType(CV_VALUE_EDITORIAL_PROJECT_STATUS)
  }

  private async loadLanguage() {
    this.cvLanguage = await CvValueUtils.getCvValuesByType(CV_VALUE_LANGUAGE)
  }

  private async loadCourseLevel() {
    this.cvCourseLevel = await CvValueUtils.getCvValuesByType(CV_VALUE_COURSE_LEVEL)
  }

  private async loadDevelopmentManagers() {
    const response = await ApiClient.getDevelopmentManagers()
    this.developmentManagers = response
  }

  private getCvValueName(codeId: string, type: string) {
    const typeName = CvValueUtils.getCvValueName(codeId, type)
    if (typeName === codeId) {
      return ''
    }
    return typeName
  }

  private getCvValueIcon(codeId: string, type: string) {
    const cvValue = CvValueUtils.getCvValue(codeId, type)
    if (!cvValue) {
      return ''
    }
    return cvValue.icon
  }

  private search() {
    this.$emit('search')
  }

  private resetSearch() {
    this.$emit('resetSearch')
  }
}
